import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';
import { Mail, Users } from 'lucide-react';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import AccessPage from '@/features/dashboard/access/pages/AccessPage.tsx';
import { type ScreenTab } from '@/components/ui/TabScreen.tsx';

export enum AccessTab {
  CURRENT = 'current',
  INVITED = 'invited',
}

export const ACCESS_TABS: readonly ScreenTab<AccessTab>[] = [
  {
    value: AccessTab.CURRENT,
    label: 'Obecni',
    icon: Users,
    hint: 'osoby z dostępem',
  },
  {
    value: AccessTab.INVITED,
    label: 'Zaproszeni',
    icon: Mail,
    hint: 'wysłane zaproszenia',
  },
];

const searchSchema = z.object({
  // Brak zakładki to menu na wąskim ekranie — patrz `TabScreen`.
  tab: z.enum(AccessTab).optional().catch(undefined),
});

export const accessRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/access',
  component: AccessPage,
  validateSearch: searchSchema,
});
